import React from 'react'
import chroma from 'chroma-js';


export const MapLegend = ({ colorRange, numColors, maxValue, minValue, parameterUnit }) => {

    //const colorRange = ['white', 'red']; // Define the start and end colors
    //const numColors = 10; // Number of colors to generate in between the start and end colors

    const legendStyles = {
        legend: {
            position: 'absolute',
            top: 70,
            right: 20,
            width: '200px',
            maxHeight: 'calc(100vh - 100px)',
            alignContent: 'end'
        },
        legendItem: {
            marginBottom: '0px',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 5
        },
        legendColor: {
            height: '20px',
            marginRight: '5px',
            padding:'0px',
            margin:'0px',
            width: 20
        },
        legendLabel: {
            fontSize: '12px',
            height: '20px',
            color: 'white',
            padding:'0px',
            marginLeft:'5px'
        }


    };



    const colors = chroma.scale(colorRange).colors(numColors);
    return (
        <div style={legendStyles.legend}>
            {colors.map((color, index) => (
                <div key={index} className="legend-item" style={legendStyles.legendItem}>
                    <div xs={6} className="legend-label" style={legendStyles.legendLabel}>
                        {index===0? `${minValue} ${parameterUnit}`:""}
                        {index===19? `${maxValue} ${parameterUnit}`:""}
                    </div>
                    <div xs={3} className="legend-color" style={{ ...legendStyles.legendColor, backgroundColor: color }} />
                </div>
            ))}
        </div>
    );
};

